<template>
  <div>
    <div :id="chartName"
         style="width: 100%; background-color: #FFFFFF;"
         :style="'height: ' + height"></div>
  </div>
</template>
<script>
  import moment from 'moment'
  import randomColor from 'randomcolor'
  import _ from 'lodash'

  require('amcharts3')
  require('amcharts3/amcharts/serial')
  require('amcharts3/amcharts/themes/light')
  export default {
    name: 'DispositifRadar',
    props: {
      entities: {
        type: Array,
        required: true
      },
      entityKey: {
        type: String,
        required: true
      },
      entityParam: {
        type: String,
        default: 'date'
      },
      chartType: {
        type: String,
        default: 'line'
      },
      chartName: {
        type: String,
        default: 'chart'
      },
      height: {
        type: String,
        default: '500px'
      },
      customName: {
        type: Function,
        default (val) {
          return val.name
        }
      }
    },
    methods: {
      dirtyInit () {
        let data = this.processData(this.entities)
        this.makeChart(this.chartName, data)
      },
      processData (entities) {
        let data = {
          dataProvider: [],
          graphs: []
        }

        let keys = entities.map(x => {
          return x.rdvs.map(y => {
            return this.customName(y)
          })
        })

        let addEntry = function (date, entity = null) {
          let entry = {date}
          keys.forEach(k => {
            k.forEach(l => {
              entry[l] = 0
            })
          })
          return entry
        }

        let scale = 'YYYY-MM'
        let tmpData = {}
        let graphKeys = {}

        entities.forEach(entity => {
          if (entity.data) {
            let entityData = entity.data[this.entityKey] || []
            entityData.forEach(x => {
              let name = this.customName(x)
              let entityPk = this.customName(x)

              if ((entityPk in graphKeys) === false) {
                graphKeys[entityPk] = {
                  pk: entityPk,
                  name,
                  _color: randomColor({entityPk})
                }
              }
              let date = moment(x[this.entityParam])
              date = date.format(scale)

              if (!(date in tmpData)) {
                tmpData[date] = addEntry(date, entity)
              }
              tmpData[date][name] += 1
            })
          }
        })

        tmpData = Object.values(tmpData)
        tmpData.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date)
        })
        let colors = ['#41B3EF', '#4151EF', '#301B7D']
        graphKeys = _(graphKeys).toPairs().sortBy(0).fromPairs().value() // sort by RDV Type
        Object.values(graphKeys).forEach((e, i) => {
          let graph = {
            balloonText: '[[title]] : [[value]]',
            bullet: 'round',
            fillAlphas: 0.73,
            fillColors: colors[i % 3],
            lineColor: colors[i % 3],
            lineThickness: 2,
            id: e.name,
            title: e.name,
            valueField: e.name
          }
          data.graphs.push(graph)
        })

        data.dataProvider = tmpData
        return data
      },
      makeChart (container, data) {
        window.AmCharts.makeChart(container,
          {
            type: 'serial',
            categoryField: 'date',
            path: 'static/amcharts',
            color: '#CCC',
            fontFamily: 'Roboto',
            fontSize: 10,
            // dataDateFormat: 'YYYY-MM',
            // categoryAxis: {
            //   gridPosition: 'start',
            //   gridColor: '#CCC',
            //   axisColor: '#CCC'
            // },
            // graphs: data.graphs.slice(),
            valueAxes: [
              {
                id: 'ValueAxis-1',
                axisTitleOffset: '20',
                minimum: 0,
                axisAlpha: 0.15,
                integersOnly: true
              }
            ],
            chartCursor: {
              enabled: true,
              animationDuration: 0.30,
              cursorAlpha: 0.50,
              cursorColor: '#000'
            },
            // legend: {
            //   enabled: true,
            //   useGraphSettings: true
            // },
            // titles: [
            //   {
            //     alpha: 0,
            //     id: 'Title-1',
            //     size: 15
            //   }
            // ],
            dataProvider: data.dataProvider.slice()
          }
        )
      }
    },
    mounted () {
      this.dirtyInit()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/Charts/DispositifRadar.vue